import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';

import Section from 'components/structure/Section';
import Block from 'components/structure/Block/Block';
import Carousel from 'components/Carousel/Carousel';

const quotes = [
  {
    intlKey: 'NU_ENVIRONMENT',
    href:
      'https://qz.com/work/1732111/nubank-is-pushing-fintech-companies-to-prioritize-inclusivity/',
    source: 'Quartz',
  },
  {
    intlKey: 'NU_ONBOARDING',
    href:
      'https://www.valor.com.br/carreira/6425259/o-que-muda-na-maneira-de-recrutar-das-startups',
    source: ' Valor Econômico',
  },
  {
    intlKey: 'DIVERSITY',
    href:
      'http://www1.folha.uol.com.br/mercado/2016/12/1839170-nubank-recebe-investimento-de-us-80-milhoes-e-quer-atrair-mais-clientes.shtml',
    source: 'Época Negócios',
  },
];

class SectionPress extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentStep: 1,
    };
  }

  handleChangeCarouselStep = step => {
    this.setState(() => ({
      currentStep: step,
    }));
  };

  render() {
    const { currentStep } = this.state;

    return (
      <Section
        backgroundColor="white.dark"
        minHeight="70vh"
      >
        <Block blockWidth="100%" textAlign="center" justifyContent="center">
          <Carousel
            currentStep={currentStep}
            onStepChanged={this.handleChangeCarouselStep}
          >
            {quotes.map(quote => (
              <div key={quote.intlKey}>
                <Typography
                  variant="subtitle"
                  tag="p"
                  gutterBottom={2}
                >
                  <FormattedMessage id={`CAREERS.PRESS.${quote.intlKey}`}>
                    {([txt]) => `"${txt}"`}
                  </FormattedMessage>
                </Typography>
                <Link color="primary" href={quote.href} variant="action">
                  {quote.source}
                </Link>
              </div>
            ))}
          </Carousel>
        </Block>
      </Section>
    );
  }
}

export default SectionPress;
